import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Sidebar from "../../component/Sidebar";
import Topbar from "../../component/Topbar";
import { FiUpload, FiTrash, FiSave, FiEdit, FiFileText, FiDollarSign, FiCalendar, FiTag, FiUser, FiHash, FiAlignLeft, FiCreditCard, FiCheckCircle, FiArrowLeft, FiExternalLink } from "react-icons/fi";
import $ from 'jquery';
import 'jquery-ui/themes/base/all.css';
import 'jquery-ui/ui/widgets/datepicker';
import axios from "axios";
import { baseurl, imgurl } from "../../baseurl";
import Swal from "sweetalert2";
import { RxOpenInNewWindow } from "react-icons/rx";

/* ─── constants (unchanged) ─── */
const EXPENSE_CATEGORIES = [
  "Utilities","Office Supplies","Rent","Maintenance",
  "Salary","Employee Benefits","Professional Fees","Training",
  "Marketing","Advertising","Public Relations",
  "Travel","Transportation","Logistics/Shipping","Food",
  "Software/SaaS","Hardware",
  "Insurance","Taxes & Licenses","Bank Charges","Other",
];
const PAYMENT_MODES  = ["Cash","UPI","Bank Transfer","Cheque","Card"];
const PAYMENT_STATUS = ["Paid","Unpaid","Pending","Partially Paid"];

const Toast = Swal.mixin({
  toast: true, position: "top-end",
  showConfirmButton: false, timer: 3000, timerProgressBar: true,
});

/* ─── CSS ─── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;600;700;800&family=DM+Sans:wght@400;500;600&display=swap');

:root {
  --ee-teal:      #0a5556;
  --ee-teal-mid:  #0c7172;
  --ee-teal-lite: #14b8a6;
  --ee-gold:      #FFD166;
  --ee-bg:        #eef6f6;
  --ee-white:     #ffffff;
  --ee-border:    rgba(10,85,86,0.10);
  --ee-text:      #0f2a2a;
  --ee-muted:     #5a8080;
  --ee-danger:    #ef4444;
}

@keyframes ee__fadeUp  { from{opacity:0;transform:translateY(16px)} to{opacity:1;transform:translateY(0)} }
@keyframes ee__shimmer { 0%{background-position:-600px 0} 100%{background-position:600px 0} }
@keyframes ee__spin    { to{transform:rotate(360deg)} }

.ee__wrap {
  font-family:'DM Sans',sans-serif;
  padding:22px 22px 40px;
  background:var(--ee-bg);
  min-height:100vh;
  animation:ee__fadeUp 0.4s ease both;
}

/* ── header ── */
.ee__hd { display:flex; align-items:flex-start; justify-content:space-between; gap:16px; margin-bottom:24px; flex-wrap:wrap; }
.ee__hd-left { display:flex; align-items:center; gap:14px; }
.ee__hd-icon {
  width:48px; height:48px; border-radius:14px; flex-shrink:0;
  background:linear-gradient(135deg,var(--ee-teal),var(--ee-teal-lite));
  display:flex; align-items:center; justify-content:center;
  font-size:20px; color:#fff;
  box-shadow:0 6px 18px rgba(10,85,86,0.26);
}
.ee__hd-title { font-family:'Sora',sans-serif; font-size:20px; font-weight:800; color:var(--ee-text); letter-spacing:-0.03em; margin:0 0 3px; }
.ee__hd-sub   { font-size:12.5px; color:var(--ee-muted); margin:0; }
.ee__back-btn {
  display:inline-flex; align-items:center; gap:7px;
  padding:9px 16px; border-radius:11px; border:none; cursor:pointer;
  font-size:13px; font-family:'Sora',sans-serif; font-weight:700;
  color:var(--ee-teal); background:rgba(10,85,86,0.07);
  border:1.5px solid rgba(10,85,86,0.16);
  transition:background 0.16s;
}
.ee__back-btn:hover { background:rgba(10,85,86,0.13); }

/* ── layout ── */
.ee__layout { display:grid; grid-template-columns:1fr 340px; gap:20px; align-items:start; }

/* ── card ── */
.ee__card {
  background:var(--ee-white); border-radius:20px;
  border:1px solid var(--ee-border);
  box-shadow:0 2px 20px rgba(10,85,86,0.07),0 8px 40px rgba(0,0,0,0.03);
  overflow:hidden; position:relative; margin-bottom:20px;
}
.ee__card:last-child { margin-bottom:0; }
.ee__card::before {
  content:''; position:absolute; top:0; left:0; right:0; height:3px;
  background:linear-gradient(90deg,var(--ee-teal) 0%,var(--ee-teal-lite) 55%,var(--ee-gold) 100%);
}
.ee__sec-hd {
  display:flex; align-items:center; gap:10px;
  padding:16px 22px 12px; border-bottom:1px solid var(--ee-border);
}
.ee__sec-icon {
  width:32px; height:32px; border-radius:10px; flex-shrink:0;
  background:linear-gradient(135deg,var(--ee-teal),var(--ee-teal-lite));
  display:flex; align-items:center; justify-content:center;
  font-size:14px; color:#fff; box-shadow:0 4px 10px rgba(10,85,86,0.22);
}
.ee__sec-title { font-family:'Sora',sans-serif; font-size:13px; font-weight:700; color:var(--ee-text); }
.ee__body    { padding:20px 22px; }
.ee__body-sm { padding:16px 20px; }

/* ── label ── */
.ee__lbl {
  display:flex; align-items:center; gap:6px;
  font-size:10.5px; font-weight:700; color:var(--ee-text);
  margin-bottom:6px; letter-spacing:0.06em; text-transform:uppercase;
}
.ee__lbl-dot { width:5px; height:5px; border-radius:50%; background:var(--ee-teal); flex-shrink:0; }
.ee__req { color:var(--ee-danger); margin-left:2px; }
.ee__opt { font-size:9px; color:#9ababa; background:rgba(10,85,86,0.06); border:1px solid #c8e4e4; border-radius:50px; padding:1px 7px; margin-left:4px; text-transform:none; letter-spacing:0; }

/* ── inputs ── */
.ee__input, .ee__select, .ee__textarea {
  width:100%; padding:10px 13px;
  font-size:13px; font-family:'DM Sans',sans-serif; color:var(--ee-text);
  background:#f3fafa; border:1.5px solid #c8e4e4; border-radius:11px;
  outline:none; box-sizing:border-box;
  transition:border-color 0.18s, box-shadow 0.18s, background 0.18s;
}
.ee__input:focus,.ee__select:focus,.ee__textarea:focus {
  border-color:var(--ee-teal); background:#fff;
  box-shadow:0 0 0 4px rgba(10,85,86,0.09);
}
.ee__input::placeholder,.ee__textarea::placeholder { color:#9ababa; }
.ee__input[readonly] { background:rgba(10,85,86,0.04); color:var(--ee-muted); cursor:pointer; }
.ee__select {
  appearance:none;
  background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%235a8080' stroke-width='2.5'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
  background-repeat:no-repeat; background-position:right 12px center; padding-right:32px; cursor:pointer;
}
.ee__textarea { resize:vertical; min-height:90px; }
.ee__field-wrap { position:relative; }
.ee__field-icon { position:absolute; left:11px; top:50%; transform:translateY(-50%); color:#7aadad; font-size:14px; pointer-events:none; }
.ee__input--icon { padding-left:34px; }
.ee__textarea-icon { position:absolute; left:11px; top:13px; color:#7aadad; font-size:14px; pointer-events:none; }
.ee__textarea--icon { padding-left:34px; }

/* ── grids ── */
.ee__grid2 { display:grid; grid-template-columns:1fr 1fr; gap:14px; }

/* ── amount preview ── */
.ee__amount-preview {
  background:linear-gradient(135deg,var(--ee-teal),var(--ee-teal-mid));
  border-radius:14px; padding:16px 18px; margin-bottom:16px;
}
.ee__amount-lbl { font-size:11px; font-weight:600; color:rgba(255,255,255,0.65); text-transform:uppercase; letter-spacing:0.07em; }
.ee__amount-val { font-family:'Sora',sans-serif; font-size:26px; font-weight:800; color:#fff; letter-spacing:-0.02em; }
.ee__amount-tax { font-size:12px; color:rgba(255,255,255,0.55); margin-top:4px; }

/* ── existing attachment ── */
.ee__attachment-link {
  display:inline-flex; align-items:center; gap:7px;
  padding:7px 14px; border-radius:10px; margin-bottom:10px;
  font-size:12px; font-weight:700; font-family:'Sora',sans-serif;
  color:var(--ee-teal); background:rgba(10,85,86,0.08);
  border:1.5px solid rgba(10,85,86,0.18); text-decoration:none;
  transition:background 0.15s;
}
.ee__attachment-link:hover { background:rgba(10,85,86,0.14); color:var(--ee-teal); text-decoration:none; }

/* ── upload zone ── */
.ee__upload-zone {
  border:2px dashed rgba(10,85,86,0.22); border-radius:14px;
  padding:18px 16px; text-align:center; background:#f9fdfd;
  transition:border-color 0.18s, background 0.18s;
}
.ee__upload-zone:hover { border-color:var(--ee-teal); background:rgba(10,85,86,0.03); }
.ee__upload-icon  { color:var(--ee-teal); margin-bottom:7px; font-size:20px; }
.ee__upload-label { font-family:'Sora',sans-serif; font-size:12px; font-weight:700; color:var(--ee-text); margin-bottom:3px; }
.ee__upload-sub   { font-size:11.5px; color:var(--ee-muted); margin-bottom:10px; }
.ee__upload-file-input {
  width:100%; font-size:12px; font-family:'DM Sans',sans-serif;
  background:#f3fafa; border:1.5px solid #c8e4e4; border-radius:9px;
  padding:6px 10px; outline:none; cursor:pointer;
  transition:border-color 0.16s;
}
.ee__upload-file-input:focus { border-color:var(--ee-teal); }
.ee__file-name {
  display:inline-flex; align-items:center; gap:6px; margin-top:8px;
  font-size:11.5px; font-weight:600; color:var(--ee-teal);
  background:rgba(10,85,86,0.07); border-radius:7px; padding:3px 10px;
}

/* ── buttons ── */
.ee__submit-btn {
  width:100%; padding:14px; margin-bottom:10px;
  font-size:15px; font-family:'Sora',sans-serif; font-weight:700;
  color:#fff; letter-spacing:0.04em;
  background:linear-gradient(135deg,var(--ee-teal),var(--ee-teal-mid),var(--ee-teal-lite));
  background-size:200% auto;
  border:none; border-radius:13px; cursor:pointer;
  box-shadow:0 6px 24px rgba(10,85,86,0.34);
  transition:background-position 0.4s, transform 0.14s;
  display:flex; align-items:center; justify-content:center; gap:8px;
  position:relative; overflow:hidden;
}
.ee__submit-btn::after {
  content:''; position:absolute; inset:0;
  background:linear-gradient(90deg,transparent,rgba(255,255,255,0.12),transparent);
  background-size:400px 100%; opacity:0; transition:opacity 0.3s;
}
.ee__submit-btn:hover:not(:disabled) { background-position:right center; transform:translateY(-1px); }
.ee__submit-btn:hover:not(:disabled)::after { opacity:1; animation:ee__shimmer 1.1s linear infinite; }
.ee__submit-btn:disabled { opacity:0.65; cursor:not-allowed; }
.ee__spinner {
  width:16px; height:16px; border-radius:50%;
  border:2px solid rgba(255,255,255,0.4); border-top-color:#fff;
  animation:ee__spin 0.7s linear infinite; display:inline-block;
}
.ee__cancel-btn {
  width:100%; padding:11px; border:none; cursor:pointer;
  font-size:13.5px; font-family:'Sora',sans-serif; font-weight:700;
  color:var(--ee-muted); background:transparent;
  border:1.5px solid rgba(10,85,86,0.18); border-radius:13px;
  display:flex; align-items:center; justify-content:center; gap:7px;
  transition:background 0.16s, color 0.16s, border-color 0.16s;
}
.ee__cancel-btn:hover { background:rgba(239,68,68,0.07); color:var(--ee-danger); border-color:rgba(239,68,68,0.22); }

/* ── skeleton ── */
.ee__skel {
  border-radius:8px;
  background:linear-gradient(90deg,#e8f4f4 0%,#d0eded 50%,#e8f4f4 100%);
  background-size:600px 100%;
  animation:ee__shimmer 1.4s linear infinite;
}
.ee__skel-input { height:44px; width:100%; margin-bottom:14px; }
.ee__skel-label { height:12px; width:30%; margin-bottom:8px; }
.ee__skel-title { height:22px; width:45%; margin-bottom:20px; }
.ee__skel-preview { height:82px; border-radius:14px; margin-bottom:16px; }

@media(max-width:960px){ .ee__layout{ grid-template-columns:1fr; } }
@media(max-width:600px){ .ee__grid2{ grid-template-columns:1fr; } }
`;

/* ─── Component ─── */
export default function EditExpense() {
  const { uuid }   = useParams();
  const navigate   = useNavigate();

  const [expense, setExpense] = useState({
    title:"", category:"", date:"", vendor:"",
    amount:"", taxAmount:"", referenceNo:"",
    paymentMode:"", paymentStatus:"", notes:"",
    attachment:null, existingAttachment:"",
  });
  const [loading, setLoading]   = useState(false);
  const [fetching, setFetching] = useState(true);
  const token = localStorage.getItem("auth_token");
  const dateInputRef = useRef(null);

  /* ── fetch (unchanged) ── */
  useEffect(() => {
    const fetchExpenseData = async () => {
      setFetching(true);
      try {
        const response = await axios.get(`${baseurl}getExpenseByUuid/${uuid}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.data.success) {
          const data = response.data.data;
          const dbDate = data.expense_date ? new Date(data.expense_date).toISOString().split("T")[0] : "";
          setExpense({
            title:            data.title           || "",
            category:         data.category        || "",
            date:             dbDate,
            vendor:           data.vendor          || "",
            amount:           data.amount          || "",
            taxAmount:        data.tax_amount       || "",
            referenceNo:      data.reference_no    || "",
            paymentMode:      data.payment_mode    || "",
            paymentStatus:    data.payment_status  || "",
            notes:            data.notes           || "",
            attachment:       null,
            existingAttachment: data.attachment_url || "",
          });
        }
      } catch (error) {
        Toast.fire({ icon: "error", title: "Failed to load expense data" });
      } finally {
        setTimeout(() => setFetching(false), 800);
      }
    };
    if (uuid) fetchExpenseData();
  }, [uuid, token]);

  /* ── jQuery datepicker (unchanged) ── */
  useEffect(() => {
    if (!fetching) {
      $(dateInputRef.current).datepicker({
        dateFormat: "yy-mm-dd",
        onSelect: (dateText) => updateField("date", dateText),
      });
    }
    return () => { try { $(dateInputRef.current).datepicker("destroy"); } catch (e) {} };
  }, [fetching]);

  /* ── updaters (unchanged) ── */
  const updateField      = (key, value) => setExpense(prev => ({ ...prev, [key]: value }));
  const handleFileUpload = (e)           => updateField("attachment", e.target.files[0]);

  /* ── submit (unchanged) ── */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    Object.keys(expense).forEach(key => {
      if (key !== "attachment" && key !== "existingAttachment")
        formData.append(key, expense[key] || "");
    });
    if (expense.attachment) formData.append("attachment", expense.attachment);
    try {
      await axios.put(`${baseurl}updateExpense/${uuid}`, formData, {
        headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}` },
      });
      Toast.fire({ icon: "success", title: "Expense updated successfully" });
      navigate("/expenses");
    } catch (error) {
      Toast.fire({ icon: "error", title: "Update failed" });
    } finally {
      setLoading(false);
    }
  };

  /* ── skeleton ── */
  const FormSkeleton = () => (
    <div className="ee__layout" style={{ padding:"20px 22px" }}>
      <div>
        <div className="ee__card">
          <div className="ee__sec-hd" style={{ borderBottom:"1px solid var(--ee-border)" }}>
            <div className="ee__skel" style={{ width:32, height:32, borderRadius:10 }} />
            <div className="ee__skel" style={{ width:160, height:14 }} />
          </div>
          <div className="ee__body">
            <div className="ee__skel ee__skel-label" />
            <div className="ee__skel ee__skel-input" />
            <div className="ee__grid2">
              {[1,2,3,4].map(i => (
                <div key={i}>
                  <div className="ee__skel ee__skel-label" />
                  <div className="ee__skel ee__skel-input" />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="ee__card">
          <div className="ee__body">
            <div className="ee__skel ee__skel-label" />
            <div className="ee__skel" style={{ height:80, width:"100%", borderRadius:11 }} />
          </div>
        </div>
      </div>
      <div>
        <div className="ee__card">
          <div className="ee__body-sm">
            <div className="ee__skel ee__skel-preview" />
            {[1,2,3,4].map(i => (
              <div key={i} style={{ marginBottom:14 }}>
                <div className="ee__skel ee__skel-label" />
                <div className="ee__skel ee__skel-input" style={{ marginBottom:0 }} />
              </div>
            ))}
          </div>
        </div>
        <div className="ee__card">
          <div className="ee__body-sm">
            <div className="ee__skel" style={{ height:100, borderRadius:14, marginBottom:12 }} />
            <div className="ee__skel" style={{ height:44, borderRadius:13 }} />
          </div>
        </div>
      </div>
    </div>
  );

  /* ═══ RENDER ═══ */
  return (
    <>
      <style>{CSS}</style>
      <Topbar />
      <Sidebar />
      <main className="main-wrapper">
        <div className="ee__wrap">

          {/* ── Header ── */}
          <div className="ee__hd">
            <div className="ee__hd-left">
              <div className="ee__hd-icon"><FiEdit /></div>
              <div>
                <div className="ee__hd-title">Edit Expense</div>
                <div className="ee__hd-sub">Modify your existing business expenditure records</div>
              </div>
            </div>
            <button type="button" className="ee__back-btn" onClick={() => navigate("/expenses")}>
              <FiArrowLeft size={13} /> Back to Expenses
            </button>
          </div>

          {fetching ? <FormSkeleton /> : (
            <form onSubmit={handleSubmit}>
              <div className="ee__layout">

                {/* ══ LEFT ══ */}
                <div>

                  {/* General Info */}
                  <div className="ee__card">
                    <div className="ee__sec-hd">
                      <div className="ee__sec-icon"><FiFileText size={14} /></div>
                      <div className="ee__sec-title">General Information</div>
                    </div>
                    <div className="ee__body">

                      <div style={{ marginBottom:14 }}>
                        <div className="ee__lbl"><div className="ee__lbl-dot" />Expense Title<span className="ee__req">*</span></div>
                        <div className="ee__field-wrap">
                          <FiFileText className="ee__field-icon" />
                          <input type="text" className="ee__input ee__input--icon"
                            placeholder="e.g. Monthly Office Rent"
                            value={expense.title}
                            onChange={(e) => updateField("title", e.target.value)}
                            required />
                        </div>
                      </div>

                      <div className="ee__grid2" style={{ marginBottom:14 }}>
                        <div>
                          <div className="ee__lbl"><div className="ee__lbl-dot" />Category<span className="ee__req">*</span></div>
                          <div className="ee__field-wrap">
                            <FiTag className="ee__field-icon" />
                            <select className="ee__select ee__input--icon"
                              value={expense.category}
                              onChange={(e) => updateField("category", e.target.value)}
                              required>
                              <option value="">Choose category…</option>
                              {EXPENSE_CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
                            </select>
                          </div>
                        </div>
                        <div>
                          <div className="ee__lbl"><div className="ee__lbl-dot" />Expense Date<span className="ee__req">*</span></div>
                          <div className="ee__field-wrap">
                            <FiCalendar className="ee__field-icon" />
                            <input type="text" ref={dateInputRef} className="ee__input ee__input--icon"
                              placeholder="YYYY-MM-DD"
                              value={expense.date}
                              readOnly required />
                          </div>
                        </div>
                      </div>

                      <div className="ee__grid2">
                        <div>
                          <div className="ee__lbl"><div className="ee__lbl-dot" />Vendor / Merchant<span className="ee__opt">Optional</span></div>
                          <div className="ee__field-wrap">
                            <FiUser className="ee__field-icon" />
                            <input type="text" className="ee__input ee__input--icon"
                              placeholder="Company Name"
                              value={expense.vendor}
                              onChange={(e) => updateField("vendor", e.target.value)} />
                          </div>
                        </div>
                        <div>
                          <div className="ee__lbl"><div className="ee__lbl-dot" />Reference / Invoice #<span className="ee__opt">Optional</span></div>
                          <div className="ee__field-wrap">
                            <FiHash className="ee__field-icon" />
                            <input type="text" className="ee__input ee__input--icon"
                              placeholder="REF-00123"
                              value={expense.referenceNo}
                              onChange={(e) => updateField("referenceNo", e.target.value)} />
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                  {/* Notes */}
                  <div className="ee__card">
                    <div className="ee__sec-hd">
                      <div className="ee__sec-icon"><FiAlignLeft size={14} /></div>
                      <div className="ee__sec-title">Notes &amp; Description</div>
                    </div>
                    <div className="ee__body">
                      <div className="ee__lbl"><div className="ee__lbl-dot" />Additional Notes<span className="ee__opt">Optional</span></div>
                      <div className="ee__field-wrap">
                        <FiAlignLeft className="ee__textarea-icon" />
                        <textarea className="ee__textarea ee__textarea--icon" rows="4"
                          placeholder="Enter specific details, terms, or remarks…"
                          value={expense.notes}
                          onChange={(e) => updateField("notes", e.target.value)} />
                      </div>
                    </div>
                  </div>

                </div>

                {/* ══ RIGHT ══ */}
                <div>

                  {/* Financials */}
                  <div className="ee__card">
                    <div className="ee__sec-hd">
                      <div className="ee__sec-icon"><FiDollarSign size={14} /></div>
                      <div className="ee__sec-title">Financials</div>
                    </div>
                    <div className="ee__body-sm">

                      {/* Live preview */}
                      <div className="ee__amount-preview">
                        <div className="ee__amount-lbl">Total Amount</div>
                        <div className="ee__amount-val">
                          {expense.amount ? `₹ ${Number(expense.amount).toLocaleString("en-IN")}` : "₹ 0"}
                        </div>
                        {expense.taxAmount && (
                          <div className="ee__amount-tax">Tax: ₹ {Number(expense.taxAmount).toLocaleString("en-IN")}</div>
                        )}
                      </div>

                      <div style={{ marginBottom:12 }}>
                        <div className="ee__lbl"><div className="ee__lbl-dot" />Total Amount (₹)<span className="ee__req">*</span></div>
                        <div className="ee__field-wrap">
                          <FiDollarSign className="ee__field-icon" />
                          <input type="number" className="ee__input ee__input--icon"
                            placeholder="0.00"
                            value={expense.amount}
                            onChange={(e) => updateField("amount", e.target.value)}
                            required />
                        </div>
                      </div>

                      <div style={{ marginBottom:12 }}>
                        <div className="ee__lbl"><div className="ee__lbl-dot" />Tax Component<span className="ee__opt">Optional</span></div>
                        <div className="ee__field-wrap">
                          <FiTag className="ee__field-icon" />
                          <input type="number" className="ee__input ee__input--icon"
                            placeholder="0.00"
                            value={expense.taxAmount}
                            onChange={(e) => updateField("taxAmount", e.target.value)} />
                        </div>
                      </div>

                      <div style={{ marginBottom:12 }}>
                        <div className="ee__lbl"><div className="ee__lbl-dot" />Payment Method<span className="ee__req">*</span></div>
                        <div className="ee__field-wrap">
                          <FiCreditCard className="ee__field-icon" />
                          <select className="ee__select ee__input--icon"
                            value={expense.paymentMode}
                            onChange={(e) => updateField("paymentMode", e.target.value)}
                            required>
                            <option value="">Select Method</option>
                            {PAYMENT_MODES.map(m => <option key={m} value={m}>{m}</option>)}
                          </select>
                        </div>
                      </div>

                      <div>
                        <div className="ee__lbl"><div className="ee__lbl-dot" />Payment Status<span className="ee__req">*</span></div>
                        <div className="ee__field-wrap">
                          <FiCheckCircle className="ee__field-icon" />
                          <select className="ee__select ee__input--icon"
                            value={expense.paymentStatus}
                            onChange={(e) => updateField("paymentStatus", e.target.value)}
                            required>
                            <option value="">Select Status</option>
                            {PAYMENT_STATUS.map(s => <option key={s} value={s}>{s}</option>)}
                          </select>
                        </div>
                      </div>

                    </div>
                  </div>

                  {/* Upload */}
                  <div className="ee__card" style={{ marginBottom:16 }}>
                    <div className="ee__sec-hd">
                      <div className="ee__sec-icon"><FiUpload size={14} /></div>
                      <div className="ee__sec-title">Receipt Upload</div>
                    </div>
                    <div className="ee__body-sm">
                      {expense.existingAttachment && (
                        <a href={`${imgurl}${expense.existingAttachment}`} target="_blank" rel="noreferrer"
                          className="ee__attachment-link">
                          <RxOpenInNewWindow size={13} /> View Current Receipt
                        </a>
                      )}
                      <div className="ee__upload-zone">
                        <div className="ee__upload-icon"><FiUpload /></div>
                        <div className="ee__upload-label">Replace Receipt</div>
                        <div className="ee__upload-sub">PDF, JPG, PNG supported</div>
                        <input type="file" className="ee__upload-file-input" onChange={handleFileUpload} />
                      </div>
                      {expense.attachment && (
                        <div style={{ textAlign:"center" }}>
                          <span className="ee__file-name"><FiFileText size={11} />{expense.attachment.name}</span>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Actions */}
                  <button type="submit" className="ee__submit-btn" disabled={loading}>
                    {loading
                      ? <><div className="ee__spinner" /> Updating…</>
                      : <><FiSave size={15} /> Update Expense</>}
                  </button>
                  <button type="button" className="ee__cancel-btn" onClick={() => navigate("/expenses")}>
                    <FiArrowLeft size={13} /> Cancel Changes
                  </button>

                </div>

              </div>
            </form>
          )}

        </div>
      </main>
    </>
  );
}
